// Slide-Warenkorb des Themes (ersetzt die App qikify Slide Cart, 17.09.2026).
//
// Das Element heisst <mhsys-warenkorb>. Bis zum Umbau auf das Weissblau-Theme hiess es <cart-drawer>,
// weil Flux' product-form.js und quick-add.js genau nach diesem Namen suchten. Das Theme bringt jetzt
// sein eigenes Kaufformular mit (assets/mhsys-kaufformular.js) und braucht den fremden Namen nicht mehr.
//
// Den Inhalt rendert die Section Rendering API (sections/mhsys-warenkorb.liquid). Im Seiten-HTML steht
// nur die leere Huelle aus layout/theme.liquid - so bleiben die Seiten cachebar und leicht.
//
// Wege in den Warenkorb:
//   - eigenes Kaufformular und Schnellkauf: schicken ?sections mit und rufen antwortEinsetzen().
//   - alles andere (Express-Knopf der Produktseite, Apps wie Globo): jeder fremde fetch/XHR auf
//     /cart/add|change|update|clear wird bemerkt, danach wird neu geladen (und bei add geoeffnet).
//   - eigener Code: window.mhsysWarenkorb.aktualisieren(oeffnen) - so ruft es mhsys-produktempfehlungen.
//
// Auf /cart steht dasselbe Element als Seite (data-seite, sections/mhsys-warenkorb-seite.liquid): gleicher
// Inhalt, eigene Section fuer das Neurendern, Oeffnen und Schliessen tun dort nichts.
//
// Sofort reagieren (Roadmap 1.70, Shop-Analyse 06.10.2026: "+" brauchte ~0,8 s bis zur neuen Zahl, das erste
// Einlegen am Handy ~2,5 s bis die Schublade aufging):
//   - Menge: die Zeile zeigt Menge, Zeilenpreis und Zaehler sofort; gerechnet aus dem, was im Markup steht,
//     ohne Abfrage. Schnelle Klicks werden zu einem Aufruf zusammengefasst (MENGE_WARTEN). Shopifys Antwort ist
//     maßgeblich: sie wird eingesetzt, ein Fehler dreht auf den echten Stand zurueck.
//   - Einlegen: die Kaufwege rufen einlegenBeginnt() vor der Anfrage - die Schublade geht auf, eine Platzhalterzeile
//     mit Bild und Name steht oben in der Liste, der Zaehler zaehlt mit. antwortEinsetzen() ersetzt sie durch den
//     echten Inhalt, einlegenFehlgeschlagen() zeigt die Meldung in der Schublade.
if (!customElements.get("mhsys-warenkorb")) {
  const SECTION = "mhsys-warenkorb";
  const EIGEN = "X-Mhsys-Warenkorb";
  const WARENKORB_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  // So lange wird nach einem "+"/"−" auf den naechsten Klick gewartet, bevor die Menge an Shopify geht
  const MENGE_WARTEN = 350;

  // Adressen aus dem eigenen Objekt des Layouts; Rueckfall auf die Standardpfade.
  const routen = () => window.mhsysShop || {};

  // Geldbetrag aus dem gerenderten Text in Cent ("1.234,56 €" -> 123456). Nur fuer Formate mit zwei
  // Nachkommastellen - sonst NaN, und die Zeile wartet auf die Antwort.
  const MIT_CENT = /\{\{\s*amount(_with_comma_separator|_with_apostrophe_separator)?\s*\}\}/;
  function geldLesen(text) {
    if (!MIT_CENT.test(routen().geldFormat || "{{amount_with_comma_separator}}")) return NaN;
    const ziffern = String(text || "").replace(/\D/g, "");
    return ziffern ? Number(ziffern) : NaN;
  }
  // Cent im Format des Shops (shop.money_format, layout/theme.liquid) - dieselbe Schreibweise wie | money
  function geldSchreiben(cent) {
    const format = routen().geldFormat || "{{amount_with_comma_separator}} €";
    return format.replace(MIT_CENT, (_, art) => {
      const [ganz, rest] = (cent / 100).toFixed(2).split(".");
      const [tausend, komma] = art === "_with_comma_separator" ? [".", ","] : art ? ["'", "."] : [",", "."];
      return ganz.replace(/\B(?=(\d{3})+(?!\d))/g, tausend) + komma + rest;
    });
  }
  // Aufpreiszeilen (_gpo_parent_product_group), deren Menge nicht der ihres Artikels (_gpo_product_group) folgt:
  // { updates: Schluessel -> Menge, gekappt: Schluessel eines Artikels, dessen Aufpreis mehr war als er selbst }
  function anhangAbweichung(korb) {
    const artikel = {};
    const haupt = {};
    korb.items.forEach((i) => {
      const g = i.properties && i.properties._gpo_product_group;
      if (!g) return;
      artikel[g] = (artikel[g] || 0) + i.quantity;
      haupt[g] = i.key;
    });
    const updates = {};
    let gekappt = null;
    korb.items.forEach((i) => {
      const g = i.properties && i.properties._gpo_parent_product_group;
      if (!g || !artikel[g] || i.quantity === artikel[g]) return;
      updates[i.key] = artikel[g];
      if (i.quantity > artikel[g]) gekappt = haupt[g];
    });
    return { updates, gekappt };
  }
  const textSchuetzen = (s) =>
    String(s || "").replace(/[&<>"]/g, (z) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[z]);

  // Eigene Fokusfalle - keine Uebernahme aus fremdem Code.
  const FOKUSSIERBAR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // Schnellansicht aus der Schublade (Roadmap 4.12). Ihr Skript laedt erst beim ersten Klick (Adresse und
  // Schalter in window.mhsysSchnellansicht, layout/theme.liquid) - ein Versprechen fuer alle Klicks, und
  // solange es laedt, zaehlt kein weiterer Klick: ein Doppelklick laedt es nicht zweimal und oeffnet nicht
  // zweimal. Liefert false, wenn der normale Link greifen soll (Schalter aus, kein Skript).
  let saLaden = null;
  let saWartet = false;
  function schnellansichtAn(cfg) {
    if (cfg.an) return true;
    try {
      return localStorage.getItem("mhSchnellansichtTest") === "1";
    } catch (e) {
      return false;
    }
  }
  // Skript und Huelle laden - EIN Promise fuer Klick und Vorladen (Roadmap 4.14), nichts laedt doppelt
  function schnellansichtLaden(cfg) {
    if (!saLaden) {
      // Das CSS der Huelle mit, sonst stuende "Wird geladen" kurz ungestaltet am Seitenende
      const css = !cfg.huelle || document.querySelector(`link[href="${CSS.escape(cfg.huelle)}"]`)
        ? Promise.resolve()
        : new Promise((fertig) => {
            const l = document.createElement("link");
            l.rel = "stylesheet";
            l.href = cfg.huelle;
            l.onload = l.onerror = () => fertig();
            document.head.appendChild(l);
          });
      const skript = new Promise((fertig, fehler) => {
        const s = document.createElement("script");
        s.src = cfg.skript;
        s.onload = fertig;
        s.onerror = fehler;
        document.head.appendChild(s);
      });
      saLaden = Promise.all([skript, css]);
      saLaden.catch(() => {
        saLaden = null;
      });
    }
    return saLaden;
  }
  // Vorladen im Leerlauf, sobald die Schublade offen ist und einen Schnellansicht-Link hat (Roadmap 4.14): unter
  // "Slow 4G" dauerte der erste Klick sonst rund 0,7 s ohne jede Rueckmeldung, solange das Skript nachlud. Beim
  // Seitenaufruf laedt davon nichts - erst die geoeffnete Schublade stoesst es an.
  function schnellansichtVorladen(wurzel) {
    if (saLaden || typeof window.mhsysSchnellansichtOeffnen === "function") return;
    const cfg = window.mhsysSchnellansicht || {};
    if (!cfg.skript || !schnellansichtAn(cfg) || !wurzel.querySelector("[data-wk-schnellansicht]")) return;
    const los = () => {
      if (!saLaden) schnellansichtLaden(cfg).catch(() => {});
    };
    if ("requestIdleCallback" in window) window.requestIdleCallback(los, { timeout: 2000 });
    else setTimeout(los, 300);
  }
  function schnellansichtOeffnen(link) {
    if (typeof window.mhsysSchnellansichtOeffnen === "function") return window.mhsysSchnellansichtOeffnen(link) !== false;
    const cfg = window.mhsysSchnellansicht || {};
    if (!cfg.skript || !schnellansichtAn(cfg)) return false;
    if (saWartet) return true;
    saWartet = true;
    const ziel = link.href;
    schnellansichtLaden(cfg)
      .then(() => {
        saWartet = false;
        const oeffnen = window.mhsysSchnellansichtOeffnen;
        if (typeof oeffnen !== "function" || oeffnen(link) === false) window.location.href = ziel;
      })
      .catch(() => {
        saWartet = false;
        window.location.href = ziel;
      });
    return true;
  }

  // Kurzes Vibrieren, wenn etwas im Korb ist (Roadmap 1.78) - nur wo das Geraet es kann (Android; iPhones im
  // Browser nicht) und nie bei "Bewegung reduzieren"
  function vibrieren() {
    if (!navigator.vibrate || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    try {
      navigator.vibrate(18);
    } catch (e) {
      /* manche Browser verweigern es ohne Tipp - dann eben nicht */
    }
  }

  class MhsysWarenkorb extends HTMLElement {
    connectedCallback() {
      if (this.bereit) return;
      this.bereit = true;
      this.inhalt = this.querySelector("[data-wk-inhalt]");
      this.seite = this.hasAttribute("data-seite");
      this.section = this.dataset.section || SECTION;
      this.leiste = this.querySelector("[data-wk-leiste]");
      this.geladen = false;
      // Jede Anfrage bekommt eine Nummer; eine Antwort, die aelter ist als die zuletzt eingesetzte, wird verworfen
      this.anfrageNr = 0;
      this.eingesetztNr = 0;
      // Gewuenschte Mengen, die schon zu sehen, aber noch nicht bei Shopify sind: Schluessel -> Menge
      this.mengeWuensche = new Map();
      // Laufende Einlege-Vorgaenge (einlegenBeginnt bis zur Antwort) und ihr Platzhalter
      this.einlegenOffen = 0;
      this.platzhalter = null;

      this.addEventListener("click", (e) => this.beiKlick(e));
      this.addEventListener("change", (e) => this.beiAenderung(e));
      this.addEventListener("submit", (e) => this.vorDerKasse(e));
      // Seite verlassen, waehrend eine Menge noch wartet: jetzt senden (fetch mit keepalive ueberlebt den Wechsel)
      window.addEventListener("pagehide", () => {
        if (!this.mengeWuensche.size) return;
        this.laufend = 0;
        this.mengeSenden();
      });
      this.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this.close();
      });

      this.symbolVerbinden();
      this.fremdeAufrufeBeobachten();

      // Auf /cart (data-seite) steht der Inhalt schon beim Laden server-gerendert da - open()/laden()
      // fasst ihn nie an (this.seite bricht dort ab), also liefe die Pruefung in einsetzen() erst beim
      // naechsten Neurendern. Hier einmal direkt gegen das schon vorhandene Markup.
      if (this.seite) setTimeout(() => this.wunschterminPruefen(), 0);
      // Dasselbe fuer die Mindestbestellmenge (Roadmap 3.11)
      if (this.seite) setTimeout(() => this.mindestmengePruefen(), 0);
      // Und die Aufpreiszeilen (anhangPruefen)
      if (this.seite) setTimeout(() => this.anhangPruefen(), 0);

      // Kein Vorladen im Leerlauf: der Inhalt enthaelt die Express-Bezahlknoepfe, die PayPal- und Google-Pay-
      // Rahmen nachladen (rund 150 Anfragen) - der Browser-Tab zeigte danach wieder "laedt" (17.09.2026).
      // Vorgeladen wird nur, wenn jemand aufs Warenkorb-Symbol zeigt oder tippt (symbolVerbinden).
    }

    // ---- Schnittstelle fuer das eigene Kaufformular ----

    // Name der Section, die das Kaufformular als ?sections mitschickt
    get sectionName() {
      return this.section;
    }

    ausloeserMerken(element) {
      this.ausloeser = element;
    }

    // Vor der Anfrage an /cart/add.js (Roadmap 1.70): Schublade auf, Platzhalterzeile, Zaehler + menge.
    // daten = { name, bild, menge }; ausloeser bekommt beim Schliessen den Fokus zurueck.
    einlegenBeginnt(daten, ausloeser) {
      this.einlegenOffen++;
      this.zuBeimEinlegen = false;
      this.platzhalter = daten || {};
      if (ausloeser) this.ausloeserMerken(ausloeser);
      this.symbolZaehlen(this.symbolAnzahl() + (Number(this.platzhalter.menge) || 1));
      this.platzhalterZeigen();
      // Beim Stoebern am Handy bleibt die Schublade zu, die Handyleiste meldet es (Roadmap 1.78, siehe leiseMoeglich)
      this.leise = this.leiseMoeglich(ausloeser);
      if (this.leise) this.leisteMelden("laeuft", this.platzhalter);
      else this.open();
    }

    // Antwort von /cart/add.js einsetzen und oeffnen - der Platzhalter weicht dem echten Inhalt. Hat der Kunde
    // die Schublade in der Wartezeit geschlossen, bleibt sie zu.
    antwortEinsetzen(antwort) {
      if (this.einlegenOffen) this.einlegenOffen--;
      const html = antwort && antwort.sections && antwort.sections[this.section];
      const ok = antwort && (antwort.id || antwort.key || antwort.items);
      const leise = this.leise;
      if (!this.einlegenOffen) this.leise = false;
      if (html) this.einsetzen(html, ++this.anfrageNr);
      else this.laden();
      if (ok) vibrieren();
      if (ok && leise) this.leisteMelden("drin");
      else if (ok && !this.zuBeimEinlegen) this.open();
    }

    // Einlegen fehlgeschlagen: Meldung in der Schublade statt eines leeren Korbs, dann der echte Stand
    // (Inhalt und Zaehler) - die Meldung steht danach wieder da (meldungZeigen nach dem Einsetzen).
    einlegenFehlgeschlagen(text) {
      // Leise eingelegt und schiefgegangen: die Schublade zeigt die Meldung - sie muss dafuer aufgehen. Und zwar
      // BEVOR das Einlegen abgezaehlt ist: open() startet sonst bei einer nie geladenen Schublade ein eigenes
      // laden(), dessen Antwort spaeter ohne Meldung einsetzt (Pruefbericht 08.10.2026). So laedt nur der Aufruf unten.
      if (this.leise) {
        this.leise = false;
        this.leisteMelden("weg");
        this.open();
      }
      if (this.einlegenOffen) this.einlegenOffen--;
      if (!this.einlegenOffen) this.inhalt.querySelectorAll("[data-wk-platzhalter]").forEach((p) => p.remove());
      // Shopifys Satz unveraendert - derselbe steht am Formular ("Das Produkt ist bereits ausverkauft.")
      this.fehlerMerken(null, text, true);
      const meldung = this.meldung;
      this.meldungZeigen();
      this.meldung = meldung;
      return this.laden();
    }

    nurNeuLaden() {
      return this.laden();
    }

    // ---- Zuletzt angeschaut im leeren Korb (Roadmap 1.78, Inhaber 07.10.2026) ----
    // Der leere Korb zeigt ueber "Aus unseren TOP 50" bis zu drei Artikel aus dem Verlauf (assets/mhsys-verlauf.js,
    // nur im Browser gemerkte Handles) - als dieselben Kacheln mit "+" (snippets/mhsys-wk-leer-kachel.liquid).
    // EIN Abruf ueber die Shop-Suche (sections/mhsys-wk-zuletzt.liquid), je Handle-Liste einmal gemerkt.
    // Nur am Handy (unter 750 px - am Rechner bleibt alles wie live) und nur in der Schublade: auf der Seite /cart
    // schoebe der nachtraeglich eingesetzte Block die TOP 50 darunter nach unten (Layoutsprung, Pruefbericht 08.10.2026).
    zuletztFuellen() {
      if (this.seite || !window.matchMedia("(max-width: 749px)").matches) return;
      const bereich = this.inhalt.querySelector("[data-wk-zuletzt]");
      if (!bereich || !window.mhsysVerlauf) return;
      const handles = window.mhsysVerlauf.lesen().slice(0, 3);
      if (!handles.length) return;
      const frage = handles.map((h) => `handle:"${h.replace(/"/g, "")}"`).join(" OR ");
      const url = `${routen().suchUrl || "/search"}?type=product&q=${encodeURIComponent(frage)}&section_id=mhsys-wk-zuletzt`;
      if (!this.zuletztAbruf || this.zuletztAbruf.url !== url) {
        this.zuletztAbruf = { url, html: fetch(url).then((r) => (r.ok ? r.text() : "")).catch(() => "") };
      }
      this.zuletztAbruf.html.then((html) => {
        if (!html || !bereich.isConnected) return;
        const doc = new DOMParser().parseFromString(html, "text/html");
        const karten = {};
        doc.querySelectorAll("[data-wk-zuletzt-handle]").forEach((k) => (karten[k.dataset.wkZuletztHandle] = k));
        const liste = bereich.querySelector("[data-wk-zuletzt-liste]");
        // In der Reihenfolge des Verlaufs, nicht der Suche
        handles.forEach((h) => {
          if (karten[h]) liste.appendChild(document.importNode(karten[h], true));
        });
        if (liste.childElementCount) bereich.hidden = false;
      });
    }

    // ---- Leise einlegen (Roadmap 1.78, Inhaber 07.10.2026: "Im Kerberl in der Leiste, solange man stoebert") ----
    // Wer am Handy auf einer Kollektion, der Suche oder einer Artikelreihe "+" tippt, will weiterstoebern: die
    // Schublade bleibt zu, die Handyleiste zeigt "Kommt ins Kerberl …" und gleich darauf "✓ Im Kerberl" mit Anzahl,
    // Rest bis versandfrei und "Ansehen". Einlegen, Platzhalter, Zaehler und Antwort laufen genau wie sonst - nur
    // open() unterbleibt. Nur, wenn die Leiste wirklich zu sehen ist; sonst (Rechner, Tastatur offen, Kaufleiste,
    // ein Overlay, die Schublade schon offen) wie bisher. Schlaegt das Einlegen fehl, geht die Schublade auf.
    leiseMoeglich(ausloeser) {
      if (this.seite || this.classList.contains("is-offen")) return false;
      if (!ausloeser || !ausloeser.closest(".mhsys-kachel")) return false;
      if (ausloeser.closest("dialog, [role='dialog'], [data-merk-overlay]")) return false;
      const html = document.documentElement.classList;
      if (["mhsys-tippt", "mhsys-kaufleiste-an", "mhsys-overlay-offen", "mhsys-wk-offen"].some((k) => html.contains(k))) return false;
      const nav = document.querySelector("[data-mhsys-handyleiste]");
      return !!nav && getComputedStyle(nav).display !== "none";
    }

    leisteMelden(zustand, daten) {
      const nav = document.querySelector("[data-mhsys-handyleiste]");
      if (!nav) return;
      let m = nav.querySelector("[data-hl-meldung]");
      if (!m) {
        m = document.createElement("div");
        m.className = "mhsys-hl-meldung";
        m.setAttribute("data-hl-meldung", "");
        m.setAttribute("role", "status");
        m.hidden = true;
        m.innerHTML =
          '<span class="mhsys-hl-meldung__haken" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
          '<span class="mhsys-hl-meldung__text"><b data-hl-m-titel></b><small data-hl-m-zeile></small></span>' +
          '<button type="button" class="mhsys-hl-meldung__knopf" data-hl-m-ansehen>Ansehen</button>';
        m.querySelector("[data-hl-m-ansehen]").addEventListener("click", () => {
          this.leisteMelden("weg");
          this.open(nav.querySelector("[data-hl-m-ansehen]"));
        });
        // Solange der Finger drauf ist, bleibt die Meldung stehen
        m.addEventListener("touchstart", () => clearTimeout(this.meldungWeg), { passive: true });
        m.addEventListener("touchend", () => this.leisteMelden("spaeter"), { passive: true });
        nav.appendChild(m);
      }
      clearTimeout(this.meldungWeg);
      if (zustand === "weg") {
        m.classList.remove("is-da");
        this.meldungWeg = setTimeout(() => (m.hidden = true), 250);
        return;
      }
      if (zustand === "spaeter") {
        this.meldungWeg = setTimeout(() => this.leisteMelden("weg"), 2500);
        return;
      }
      const titel = m.querySelector("[data-hl-m-titel]");
      const zeile = m.querySelector("[data-hl-m-zeile]");
      if (zustand === "laeuft") {
        m.classList.add("is-laeuft");
        titel.textContent = "Kommt ins Kerberl …";
        zeile.textContent = (daten && daten.name) || "";
      } else {
        m.classList.remove("is-laeuft");
        titel.textContent = "Im Kerberl";
        // Der Rest bis versandfrei aus der eben eingesetzten Schublade (dieselbe Rechnung); ohne ihn die Anzahl aus dem
        // Zaehler. Beides zusammen passte bei 375 px nicht in die Zeile ("1 Artikel · noch 56,50 € bis versa…",
        // Pruefbericht 08.10.2026) - die Anzahl steht ohnehin am Warenkorb-Symbol.
        const n = this.symbolAnzahl();
        const ziel = this.inhalt.querySelector(".mhsys-wk__ziel-text");
        let versand = "";
        if (ziel) {
          const t = ziel.textContent.replace(/\s+/g, " ").trim();
          const rest = t.match(/Noch\s+(.+?)\s+und/i);
          versand = rest ? "noch " + rest[1] + " bis versandfrei" : /keine Versandkosten|kostenlos/i.test(t) ? "versandkostenfrei" : "";
        }
        zeile.textContent = versand || (n === 1 ? "1 Artikel" : n + " Artikel");
        this.meldungWeg = setTimeout(() => this.leisteMelden("weg"), 5000);
      }
      if (m.hidden) {
        m.hidden = false;
        void m.offsetWidth;
      }
      m.classList.add("is-da");
    }

    // Platzhalterzeile oben in der Liste (dort fuegt Shopify den neuen Artikel ein). Ohne Liste - Schublade
    // noch nie geladen oder Korb leer - ein schlanker Rahmen mit Kopf und dieser einen Zeile.
    platzhalterZeigen() {
      if (!this.einlegenOffen || this.inhalt.querySelector("[data-wk-platzhalter]")) return;
      const p = this.platzhalter || {};
      const zeile = document.createElement("li");
      zeile.className = "mhsys-wk__posten mhsys-wk__posten--platz";
      zeile.setAttribute("data-wk-platzhalter", "");
      zeile.setAttribute("aria-busy", "true");
      zeile.innerHTML =
        `<span class="mhsys-wk__bild">${p.bild ? `<img src="${textSchuetzen(p.bild)}" alt="" width="90" height="90">` : `<span class="mhsys-wk__platz-bild"></span>`}</span>` +
        `<span class="mhsys-wk__daten"><span class="mhsys-wk__name">${textSchuetzen(p.name || "")}</span>` +
        `<span class="mhsys-wk__platz-text" role="status">Kommt ins Eikaffskerberl …</span></span>`;
      let liste = this.inhalt.querySelector(".mhsys-wk__liste");
      if (!liste) {
        if (this.seite) return; // /cart ohne Artikel: die Seite bleibt, wie sie ist - die Antwort kommt gleich
        // Kopf wie in snippets/mhsys-warenkorb.liquid (Titel, X aus snippets/mhsys-icon.liquid 'xmark')
        this.inhalt.innerHTML =
          `<div class="mhsys-wk__rahmen" data-wk-anzahl="0"><div class="mhsys-wk__kopf"><div class="mhsys-wk__titel">` +
          `<p class="mhsys-wk__titel-text" id="mhsys-wk-titel">Dei Eikaffskerberl</p></div>` +
          `<button type="button" class="mhsys-wk__zu mhsys-ueberlage__zu" data-wk-zu aria-label="Schließen">` +
          `<svg class="mhsys-icon" viewBox="0 0 24 24" width="19.5" height="19.5" fill="currentColor" aria-hidden="true"><path d="M5.05 3.9c.3 0 .6.12.83.35L12 10.37l6.12-6.12a1.17 1.17 0 0 1 1.66 1.66L13.66 12l6.12 6.12a1.17 1.17 0 0 1-1.66 1.66L12 13.66l-6.12 6.12a1.17 1.17 0 0 1-1.66-1.66L10.34 12 4.22 5.88A1.17 1.17 0 0 1 5.05 3.9Z"/></svg>` +
          `</button></div><div class="mhsys-wk__koerper"><ul class="mhsys-wk__liste" role="list"></ul></div></div>`;
        liste = this.inhalt.querySelector(".mhsys-wk__liste");
      }
      liste.prepend(zeile);
      const koerper = this.inhalt.querySelector(".mhsys-wk__koerper");
      if (koerper) koerper.scrollTop = 0;
    }

    // ---- Oeffnen und Schliessen ----

    open(ausloeser) {
      if (this.seite) return;
      if (ausloeser) this.ausloeserMerken(ausloeser);
      // Beim Einlegen bringt die Antwort den Inhalt mit - kein zweiter Abruf, der den Platzhalter ueberholt
      if (!this.geladen && !this.vorlaedt && !this.einlegenOffen) this.laden();
      if (this.classList.contains("is-offen")) return;
      this.hidden = false;
      document.documentElement.classList.add("mhsys-wk-offen");
      // Reflow statt requestAnimationFrame: rAF wird in Hintergrund-Tabs gedrosselt, der Drawer hinge dann halb offen
      void this.leiste.offsetWidth;
      this.classList.add("is-offen");
      this.falleSetzen();
      schnellansichtVorladen(this.inhalt);
    }

    close() {
      if (this.seite || !this.classList.contains("is-offen")) return;
      if (this.einlegenOffen) this.zuBeimEinlegen = true;
      this.classList.remove("is-offen");
      document.documentElement.classList.remove("mhsys-wk-offen");
      this.letzterFokus = null;
      this.falleLoesen();
      setTimeout(() => {
        if (!this.classList.contains("is-offen")) this.hidden = true;
      }, 300);
    }

    // ---- Fokusfalle (eigene Umsetzung) ----

    falleSetzen() {
      if (this.beiTabTaste) return;
      this.beiTabTaste = (e) => {
        if (e.key !== "Tab") return;
        const ziele = [...this.leiste.querySelectorAll(FOKUSSIERBAR)].filter((el) => el.offsetParent !== null);
        if (!ziele.length) return;
        const erstes = ziele[0];
        const letztes = ziele[ziele.length - 1];
        if (e.shiftKey && document.activeElement === erstes) {
          e.preventDefault();
          letztes.focus();
        } else if (!e.shiftKey && document.activeElement === letztes) {
          e.preventDefault();
          erstes.focus();
        }
      };
      this.leiste.addEventListener("keydown", this.beiTabTaste);
      this.leiste.focus();
    }

    falleLoesen() {
      if (this.beiTabTaste) {
        this.leiste.removeEventListener("keydown", this.beiTabTaste);
        this.beiTabTaste = null;
      }
      if (this.ausloeser && this.ausloeser.focus) this.ausloeser.focus();
    }

    // ---- Laden und Einsetzen ----

    laden() {
      const nr = ++this.anfrageNr;
      const url = `${routen().warenkorbUrl || "/cart"}?sections=${this.section}`;
      return fetch(url, { headers: { [EIGEN]: "1" } })
        .then((r) => r.json())
        .then((s) => this.einsetzen(s[this.section], nr))
        .catch((e) => console.error("Warenkorb laden:", e));
    }

    aktualisieren(oeffnen) {
      const p = this.laden();
      if (oeffnen) this.open();
      return p;
    }

    einsetzen(html, nr, nachEntfernen) {
      if (!html) return;
      if (nr) {
        if (nr < this.eingesetztNr) return;
        this.eingesetztNr = nr;
      }
      const doc = new DOMParser().parseFromString(html, "text/html");
      const neu = doc.querySelector(".mhsys-wk__rahmen");
      if (!neu) return;

      // Scrollstand der Liste halten (Menge aendern soll nicht nach oben springen)
      const koerper = this.inhalt.querySelector(".mhsys-wk__koerper");
      const scroll = koerper ? koerper.scrollTop : 0;
      // Auf kleinen Handys scrollt der ganze Rahmen statt des Koerpers (mhsys-warenkorb.css, "Kleine Handys")
      const rahmen = this.inhalt.querySelector(".mhsys-wk__rahmen");
      const scrollRahmen = rahmen ? rahmen.scrollTop : 0;
      // Ein Schalter, der waehrend der Anfrage disabled ist, hat den Fokus schon abgegeben - dann gilt
      // der beim Klick gemerkte, aber nur solange der Fokus nicht inzwischen woanders steht.
      const frei = !document.activeElement || document.activeElement === document.body;
      const fokus = this.fokusMerken() || (frei ? this.letzterFokus : null);
      this.letzterFokus = null;

      this.inhalt.replaceChildren(document.adoptNode(neu));
      this.skripteAusfuehren(this.inhalt);
      this.geladen = true;
      if (this.classList.contains("is-offen") || this.seite) schnellansichtVorladen(this.inhalt);

      const koerperNeu = this.inhalt.querySelector(".mhsys-wk__koerper");
      if (koerperNeu) koerperNeu.scrollTop = scroll;
      if (scrollRahmen) neu.scrollTop = scrollRahmen;
      this.fokusZurueck(fokus);

      // Der Zaehler nach Shopify - plus ein Einlegen, dessen Antwort noch aussteht
      const unterwegs = this.einlegenOffen ? Number((this.platzhalter || {}).menge) || 1 : 0;
      this.symbolZaehlen(Number(neu.dataset.wkAnzahl || 0) + unterwegs);
      // Fuer den Warenkorb-Knopf der Handyleiste (Roadmap 3.134, assets/mhsys-handyleiste.js): Anzahl, Summe und Rest
      // bis versandkostenfrei aus dieser Schublade - dieselbe Rechnung, kein zweiter Abruf. zeile (snippets/mhsys-versandfrei-
      // grenze.liquid, ausgabe 'leiste'): "" = keine Zeile (unter 45 €), "12" = 12 € bis gratis, "frei"
      document.dispatchEvent(new CustomEvent("mhsys:warenkorb-stand", {
        detail: { anzahl: Number(neu.dataset.wkAnzahl || 0), summe: neu.dataset.wkSumme || "", zeile: (neu.dataset.wkHl || "").trim() },
      }));
      // Was der Kunde schon sieht, gilt weiter, bis es bei Shopify ist: noch nicht gesendete Mengen
      // (eine aeltere Antwort kam dazwischen) und der Platzhalter eines laufenden Einlegens
      this.wuenscheZeigen();
      this.platzhalterZeigen();
      this.meldungZeigen();
      this.zuletztFuellen();

      // Hat der Kunde im Warenkorb alles ausser der Express-Bearbeitung entfernt: die auch raus.
      // Nur nach eigenem Entfernen - wer auf der Express-Seite zuerst nur Express einlegt, behaelt sie.
      if (nachEntfernen && neu.dataset.wkNurExpress) {
        this.schreiben("change", { id: neu.dataset.wkNurExpress, quantity: 0 });
      }
      // Nach dem Abschluss des laufenden Schreibens (finally) pruefen, nicht mittendrin
      setTimeout(() => this.mindestmengePruefen(), 0);
      setTimeout(() => this.wunschterminPruefen(), 0);
      setTimeout(() => this.expressPruefen(), 0);
      setTimeout(() => this.anhangPruefen(), 0);
    }

    // Veralteter Wunschtermin (Roadmap 3.21 Paket C, Konzept Abschnitt 5): das Attribut bleibt am
    // Warenkorb haengen, auch wenn der Kunde erst Wochen spaeter wiederkommt. Faellt der gespeicherte
    // Tag aus der Liste (vorbei oder zu nah), rendert mhsys-versandtage.liquid kein <option> mehr
    // dafuer - der Browser waehlt dann automatisch die erste Option ("So schnell wie moeglich"), das
    // Attribut selbst steht aber weiter auf dem alten Datum. Genau das erkennt dieser Vergleich.
    wunschterminPruefen() {
      if (this.laufend) return;
      const wahl = this.inhalt.querySelector("[data-wk-termin-wahl]");
      if (!wahl) return;
      const aktuell = wahl.dataset.wkTerminAktuell || "";
      const select = wahl.querySelector("[data-wk-termin-select]");
      if (aktuell && select && select.value !== aktuell) {
        this.schreiben("update", { attributes: { Versandtag: "" } });
      }
    }

    // Fertigungszeit (Roadmap 3.38, Konzept 4.4): liegt Express im Korb und ein Artikel braucht laenger als
    // die normale Fertigung, kann "sicher morgen verschickt" nicht stimmen - Express wieder heraus, mit einem
    // Satz dazu. Das Merkmal setzt snippets/mhsys-warenkorb.liquid; nach dem Entfernen fehlt es, keine Schleife.
    // Deckt jeden Weg ab, auf dem Express dazukommt (Schalter, Express-Knopf, Express-Seite), weil jeder
    // Weg mit einem Neurendern endet.
    expressPruefen() {
      if (this.laufend) return;
      const el = this.inhalt.querySelector("[data-wk-express-raus]");
      if (!el) return;
      const tage = Number(el.dataset.wkExpressRausTage) || 0;
      // Vorbestelldatum (27.09.2026): Express geht bei Vorbestellungen nicht
      const vorbestellt = el.dataset.wkExpressRausVorbestellung;
      // Express in mhsys ausgeschaltet (SHOPS → Versand & Fristen, Roadmap 1.131)
      const aus = el.hasAttribute("data-wk-express-raus-aus");
      this.meldung = {
        text: aus
          ? "Express ist gerade pausiert und wurde herausgenommen – dein Paket kommt trotzdem zum angezeigten Datum."
          : vorbestellt
            ? `Express-Bearbeitung entfernt: deine Bestellung enthält eine Vorbestellung (Versand ab ${vorbestellt}).`
            : `Express-Bearbeitung entfernt: ein Artikel wird erst für dich gefertigt (${tage} Werktage).`,
      };
      this.schreiben("change", { id: el.dataset.wkExpressRaus, quantity: 0 });
    }

    // Liegt ein Artikel unter seiner Mindestbestellmenge im Korb (von aussen eingelegt, z. B. ein fremdes
    // Formular oder ein alter Warenkorb): hochkorrigieren und kurz sagen (Roadmap 3.11). Immer nur einer je
    // Durchgang - das Neurendern danach prueft den naechsten. Reicht der Bestand nicht, kappt menge() bei max;
    // bleibt die Menge dadurch gleich, wird nichts geschrieben (keine Schleife).
    mindestmengePruefen() {
      if (this.laufend) return;
      const zuWenig = [...this.inhalt.querySelectorAll("[data-wk-min]")].find(
        (p) => Number(p.dataset.wkMenge) < Number(p.dataset.wkMin)
      );
      if (!zuWenig) return;
      this.fehlerMerken(zuWenig, `Mindestbestellmenge: ${zuWenig.dataset.wkMin} Stück – Menge angepasst`);
      this.menge(zuWenig, Number(zuWenig.dataset.wkMin));
    }

    // Fokus ueber das Neurendern halten: replaceChildren ersetzt jedes Element, ohne das stand der Fokus nach
    // +/-, Express oder Entfernen auf <body> - wer mit der Tastatur arbeitet, war wieder am Seitenanfang
    // (Funktionstest h10, 18.09.2026). Wiedergefunden wird das Element ueber Posten und Merkmal.
    fokusMerken() {
      const el = document.activeElement;
      if (!el || el === this.inhalt || !this.inhalt.contains(el)) return null;
      const posten = el.closest("[data-wk-key]");
      return { key: posten ? posten.dataset.wkKey : "", merkmal: this.merkmal(el) };
    }

    merkmal(el) {
      const daten = [...el.attributes].find((a) => a.name.startsWith("data-wk-"));
      return `${el.tagName}|${el.getAttribute("aria-label") || el.getAttribute("name") || (daten ? daten.name : "")}`;
    }

    fokusZurueck(f) {
      if (!f) return;
      const posten = f.key && [...this.inhalt.querySelectorAll("[data-wk-key]")].find((p) => p.dataset.wkKey === f.key);
      const ziel = [...(posten || this.inhalt).querySelectorAll(FOKUSSIERBAR)].find((el) => this.merkmal(el) === f.merkmal);
      if (ziel) return ziel.focus({ preventScroll: true });
      // Posten entfernt: in der Leiste bleibt der Fokus in der Falle, auf /cart an der Ueberschrift
      const ersatz = this.seite ? this.inhalt.querySelector("h1") : this.leiste;
      if (!ersatz) return;
      if (!ersatz.hasAttribute("tabindex")) ersatz.setAttribute("tabindex", "-1");
      ersatz.focus({ preventScroll: true });
    }

    // Skripte aus innerHTML/adoptNode laufen nicht - die Express-Bezahlknoepfe von Shopify brauchen sie.
    skripteAusfuehren(wurzel) {
      wurzel.querySelectorAll("script").forEach((alt) => {
        const s = document.createElement("script");
        for (const a of alt.attributes) s.setAttribute(a.name, a.value);
        s.textContent = alt.textContent;
        alt.replaceWith(s);
      });
    }

    // ---- Schreiben ----

    // art: add | change | update. wie.sofort: die Aenderung ist schon zu sehen (Menge, Platzhalter) - dann
    // kein Abdunkeln der ganzen Schublade, nur die Summe wartet sichtbar (is-rechnet). wie.einlegen: Antwort
    // eines Einlegens aus der Schublade (Empfehlung), sie loest den Platzhalter ab.
    schreiben(art, daten, posten, wie = {}) {
      const r = routen();
      const url =
        { add: r.warenkorbHinzufuegenUrl || "/cart/add", update: r.warenkorbSetzenUrl || "/cart/update" }[art] ||
        r.warenkorbAendernUrl ||
        "/cart/change";
      const nr = ++this.anfrageNr;
      this.laufend = (this.laufend || 0) + 1;
      this.classList.add(wie.sofort ? "is-rechnet" : "is-beschaeftigt");
      return fetch(`${url}.js`.replace(/\.js\.js$/, ".js"), {
        method: "POST",
        keepalive: !!wie.sofort, // eine Menge, die der Kunde schon sieht, geht auch beim Seitenwechsel noch raus
        headers: { "Content-Type": "application/json", Accept: "application/json", [EIGEN]: "1" },
        body: JSON.stringify(
          Object.assign({}, daten, { sections: this.section, sections_url: window.location.pathname })
        ),
      })
        .then((r) => r.json())
        .then((antwort) => {
          if (antwort.status) {
            const text = antwort.description || antwort.message;
            if (wie.einlegen) return this.einlegenFehlgeschlagen(text);
            // Shopify lehnt ab (Bestand) - was der Kunde vorausgesehen hat, gilt nicht: zurueck auf Shopifys Stand
            this.wuenscheVerwerfen();
            this.fehlerMerken(posten, text);
            return this.laden();
          }
          if (wie.einlegen && this.einlegenOffen) this.einlegenOffen--;
          if (antwort.sections && antwort.sections[this.section]) this.einsetzen(antwort.sections[this.section], nr, art !== "add");
          else this.laden();
          // Eigenes Ereignis statt fremdem PubSub: darauf hoeren die uebrigen eigenen Bausteine
          // (Versandkosten-Box der Produktseite, Merkliste).
          document.dispatchEvent(
            new CustomEvent("mhsys:warenkorb-geaendert", { detail: { quelle: "warenkorb" } })
          );
        })
        .catch((e) => {
          console.error("Warenkorb:", e);
          if (wie.einlegen) return this.einlegenFehlgeschlagen("Das hat leider nicht geklappt.");
          this.fehlerMerken(posten, "Das hat leider nicht geklappt.");
          if (!wie.sofort) return this.meldungZeigen();
          // Die Zeile zeigt schon die neue Menge - ohne Antwort zurueck auf den echten Stand
          this.wuenscheVerwerfen();
          return this.laden();
        })
        .finally(() => {
          this.laufend--;
          if (!this.laufend) {
            this.classList.remove("is-beschaeftigt", "is-rechnet");
            // Mengen, die waehrend der Anfrage dazukamen, gehen jetzt in einem Aufruf hinterher
            if (this.mengeWuensche.size && !this.mengeUhr) this.mengeSenden();
          }
        });
    }

    // Die Meldung ueberlebt das Neurendern: gemerkt am Schluessel des Postens, gezeigt nach dem Einsetzen.
    fehlerMerken(posten, text, wortlaut) {
      // Shopify meldet fehlenden Bestand als langen Satz - der qikify-Text war kuerzer und klarer.
      // wortlaut = true: der eigene Satz bleibt, wie er ist.
      const bestand = !wortlaut && /stock|lager|verf[uü]gbar|only|nur noch|bereits/i.test(text || "");
      this.meldung = {
        key: posten && posten.dataset ? posten.dataset.wkKey || "" : "",
        text: bestand ? "Lagerbestand nicht ausreichend!" : text || "Das hat leider nicht geklappt.",
      };
    }

    meldungZeigen() {
      const m = this.meldung;
      if (!m) return;
      this.meldung = null;
      let ziel = null;
      if (m.key) {
        const alle = [...this.inhalt.querySelectorAll("[data-wk-key]")];
        let posten = alle.find((p) => p.dataset.wkKey === m.key);
        // Shopify vergibt nach einer Mengenaenderung einen neuen Schluessel ("variante:hash", der Hash wechselt; live
        // nachgestellt 07.10.2026) - die Meldung "Lagerbestand" landete deshalb oben statt am Artikel (Shop-Analyse
        // 06.10.2026). Dann ueber die Variante suchen, aber nur, wenn sie eindeutig ist (zwei Wunschtexte desselben
        // Artikels haben dieselbe Variante).
        if (!posten) {
          const variante = m.key.split(":")[0];
          const gleich = alle.filter((p) => (p.dataset.wkKey || "").split(":")[0] === variante);
          if (gleich.length === 1) posten = gleich[0];
        }
        if (posten) ziel = posten.querySelector("[data-wk-fehler]");
      }
      if (!ziel) ziel = this.inhalt.querySelector("[data-wk-fehler-allg]");
      // Leerer Korb und Platzhalter-Rahmen haben keine eigene Stelle dafuer: unter den Kopf (Roadmap 1.70)
      const kopf = !ziel && this.inhalt.querySelector(".mhsys-wk__kopf");
      if (kopf) {
        ziel = document.createElement("p");
        ziel.className = "mhsys-wk__fehler mhsys-wk__fehler--allg";
        ziel.setAttribute("data-wk-fehler-allg", "");
        ziel.setAttribute("role", "alert");
        kopf.after(ziel);
      }
      if (!ziel) return;
      ziel.textContent = m.text;
      ziel.hidden = false;
    }

    // Neue Menge eines Postens: sofort zeigen, nach warten ms an Shopify (0 = gleich). Weitere Klicks in der
    // Wartezeit verlaengern sie und ueberschreiben das Ziel - es geht genau ein Aufruf mit der letzten Menge.
    menge(posten, wert, warten = 0) {
      const eingabe = posten.querySelector("[data-wk-eingabe]");
      if (!eingabe) {
        if (!this.laufend) this.schreiben("change", { id: posten.dataset.wkKey, quantity: 0 }, posten); // Zusatz ohne Artikel: nur Entfernen
        return;
      }
      const max = eingabe.max ? Number(eingabe.max) : Infinity;
      let m = Math.max(0, Math.floor(Number(wert) || 0));
      // Mindestbestellmenge (Roadmap 3.11, data-wk-min): 0 entfernt, alles dazwischen wird zur Mindestmenge
      const min = Number(posten.dataset.wkMin) || 1;
      if (m > 0 && m < min) {
        this.fehlerMerken(posten, `Mindestbestellmenge: ${min} Stück`);
        m = min;
      }
      if (m > max) {
        // Eigener Satz statt "Lagerbestand nicht ausreichend!" (Shop-Analyse 06.10.2026: die Menge wurde still gekappt) -
        // ohne Zahl, der Bestand bleibt unser Wissen
        this.fehlerMerken(posten, "Mehr haben wir gerade nicht da – Menge angepasst", true);
        m = max;
      }
      this.zeileZeigen(posten, m);
      this.meldungZeigen();
      this.mengeWuensche.set(posten.dataset.wkKey, m);
      clearTimeout(this.mengeUhr);
      this.mengeUhr = null;
      if (warten > 0 && m > 0) this.mengeUhr = setTimeout(() => this.mengeSenden(), warten);
      else this.mengeSenden();
    }

    // Die gesammelten Mengen in einem Aufruf an Shopify. Laeuft gerade eine Anfrage, geht es in deren
    // finally hinterher - nie zwei Mengen-Aufrufe gleichzeitig, deren Antworten sich ueberholen koennten.
    mengeSenden() {
      clearTimeout(this.mengeUhr);
      this.mengeUhr = null;
      if (this.laufend || !this.mengeWuensche.size) return;
      const updates = {};
      let erster = null;
      this.mengeWuensche.forEach((m, key) => {
        const posten = this.postenFinden(key);
        if (!posten || m === Number(posten.dataset.wkMenge)) return;
        erster = erster || posten;
        updates[posten.dataset.wkKey] = m;
        // Globo-Zusaetze ("Dein Wunschtext") folgen der Menge ihres Artikels - im selben Aufruf
        (posten.dataset.wkAnhang || "").split(",").filter(Boolean).forEach((k) => (updates[k] = m));
      });
      this.mengeWuensche.clear();
      const schluessel = Object.keys(updates);
      if (!schluessel.length) return;
      if (schluessel.length === 1) {
        this.schreiben("change", { id: schluessel[0], quantity: updates[schluessel[0]] }, erster, { sofort: true });
      } else {
        this.schreiben("update", { updates }, erster, { sofort: true });
      }
    }

    // Posten zum Schluessel - nach einer Mengenaenderung vergibt Shopify einen neuen ("variante:hash"), dann
    // ueber die Variante, wenn sie eindeutig ist (wie meldungZeigen)
    postenFinden(key) {
      const alle = [...this.inhalt.querySelectorAll("[data-wk-key]")];
      const gleich = alle.find((p) => p.dataset.wkKey === key);
      if (gleich) return gleich;
      const variante = String(key).split(":")[0];
      const treffer = alle.filter((p) => (p.dataset.wkKey || "").split(":")[0] === variante);
      return treffer.length === 1 ? treffer[0] : null;
    }

    // Nach dem Einsetzen einer Antwort, die die noch offenen Mengen nicht kennt: sie wieder zeigen
    wuenscheZeigen() {
      if (!this.mengeWuensche.size) return;
      const neu = new Map();
      this.mengeWuensche.forEach((m, key) => {
        const posten = this.postenFinden(key);
        if (!posten) return;
        neu.set(posten.dataset.wkKey, m);
        this.zeileZeigen(posten, m);
      });
      this.mengeWuensche = neu;
    }

    wuenscheVerwerfen() {
      clearTimeout(this.mengeUhr);
      this.mengeUhr = null;
      this.mengeWuensche.clear();
    }

    // Menge, Zeilenpreis, Knoepfe und Zaehler eines Postens fuer die Menge m - ohne Abfrage. Der Stueckpreis kommt
    // aus dem gerenderten Zeilenpreis geteilt durch Shopifys Menge (data-wk-menge); Mengenrabatte zeigt erst die Antwort.
    zeileZeigen(posten, m) {
      const eingabe = posten.querySelector("[data-wk-eingabe]");
      const vorher = Number(posten.dataset.wkSicht || posten.dataset.wkMenge) || 0;
      posten.dataset.wkSicht = m;
      if (eingabe) eingabe.value = m;
      const menge = Number(posten.dataset.wkMenge) || 0;
      if (menge > 0 && m > 0) {
        posten.querySelectorAll(".mhsys-wk__preis strong, .mhsys-wk__preis s").forEach((el) => {
          const art = el.tagName === "S" ? "wkStueckAlt" : "wkStueck";
          if (!(art in el.dataset)) el.dataset[art] = geldLesen(el.textContent) / menge;
          const stueck = Number(el.dataset[art]);
          if (stueck > 0) el.textContent = geldSchreiben(Math.round(stueck * m));
        });
      }
      posten.classList.toggle("is-entfernt", m === 0);
      const min = Number(posten.dataset.wkMin) || 1;
      const minus = posten.querySelector("[data-wk-minus]");
      const plus = posten.querySelector("[data-wk-plus]");
      if (minus) minus.disabled = min > 1 && m <= min;
      if (plus && eingabe && eingabe.max) plus.disabled = m >= Number(eingabe.max);
      if (m !== vorher) {
        const anzahl = Math.max(0, this.symbolAnzahl() + m - vorher);
        this.symbolZaehlen(anzahl);
        const titel = this.inhalt.querySelector(".mhsys-wk__zaehler");
        if (titel) {
          titel.textContent = anzahl;
          titel.setAttribute("aria-label", `${anzahl} Artikel`);
        }
      }
    }

    beiKlick(e) {
      const t = e.target;
      // Klick neben die Leiste (Schleier oder das Element selbst) schliesst wie das X
      if (t.closest("[data-wk-zu]") || (!this.seite && !t.closest("[data-wk-leiste]"))) {
        e.preventDefault();
        this.close();
        return;
      }
      // "?" bei der Express-Bearbeitung (Roadmap 4.9, ersetzt das Overlay aus 3.12): der Link sitzt
      // in der Label-Zeile des Schalters - ohne preventDefault wuerde ein Klick zugleich den
      // Schalter umlegen (ein Label reicht jeden Klick an sein Feld weiter). Roadmap 4.12: als Overlay
      // ueber der Schublade (assets/mhsys-popup.js, Zurueck-Taste schliesst nur das Overlay) - aus der
      // Schublade wird nicht hinausgeleitet. Neues Tab nur noch als Rueckfall und bei Strg-/Cmd-Klick.
      // Roadmap 3.115: derselbe Weg fuer jeden Link mit data-wk-popup (Weihnachts-Fahrplan in der Versandzeile) -
      // die Schublade wird neu gezeichnet, ein data-mhsys-popup darin waere nach dem ersten Neuzeichnen ohne Horcher.
      const hilfeLink = t.closest("[data-wk-express-hilfe], [data-wk-popup]");
      if (hilfeLink) {
        e.preventDefault();
        if (typeof window.mhsysPopupOeffnen === "function" && !(e.metaKey || e.ctrlKey || e.shiftKey)) {
          window.mhsysPopupOeffnen(hilfeLink.href, hilfeLink.dataset.wkPopupTitel || "Express-Bearbeitung", { verlauf: true, ausloeser: hilfeLink });
        } else {
          window.open(hilfeLink.href, "_blank", "noopener");
        }
        return;
      }
      // Produkte in der Schublade (Positionen und Empfehlungen, Roadmap 4.12) oeffnen die Schnellansicht
      // statt der Produktseite. Ohne Schalter oder ohne Skript bleibt es der normale Link.
      const saLink = t.closest("[data-wk-schnellansicht]");
      if (saLink && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && schnellansichtOeffnen(saLink)) {
        e.preventDefault();
        return;
      }
      // Wunschtermin auf-/zuklappen (Roadmap 3.21 Paket C): reines Ein-/Ausblenden ohne
      // Serveranfrage, deshalb vor der "laufend"-Sperre - das Zuklappen soll auch waehrend
      // eine andere Aenderung unterwegs ist funktionieren.
      const terminKnopf = t.closest("[data-wk-termin-oeffnen]");
      if (terminKnopf) {
        e.preventDefault();
        const panel = terminKnopf.closest("[data-wk-termin-wahl]").querySelector("[data-wk-termin-auswahl]");
        const offen = !panel.hidden;
        panel.hidden = offen;
        terminKnopf.setAttribute("aria-expanded", String(!offen));
        if (!offen) panel.querySelector("[data-wk-termin-select]").focus();
        return;
      }
      const posten = t.closest("[data-wk-key]");
      // "+"/"−" auch waehrend einer laufenden Anfrage (Roadmap 1.70): die Zeile zeigt die Menge sofort, gesendet
      // wird gesammelt nach MENGE_WARTEN - die Reihenfolge haelt mengeSenden, nicht eine Sperre
      const schritt = t.closest("[data-wk-plus]") ? 1 : t.closest("[data-wk-minus]") ? -1 : 0;
      if (posten && schritt) {
        const eingabe = posten.querySelector("[data-wk-eingabe]");
        this.letzterFokus = this.fokusMerken();
        if (eingabe) this.menge(posten, Number(eingabe.value) + schritt, MENGE_WARTEN);
        return;
      }
      // Waehrend eine andere Aenderung laeuft, keine zweite (pointer-events sperrt nur die Maus, nicht die Tastatur)
      if (this.laufend) return;
      this.letzterFokus = this.fokusMerken();
      if (posten && t.closest("[data-wk-entfernen]")) return this.menge(posten, 0);
      // Box aus dem Baukasten (snippets/mhsys-wk-box.liquid): alle ihre Zeilen in einem Aufruf heraus (Roadmap 3.155)
      const boxWeg = t.closest("[data-wk-box-entfernen]");
      if (boxWeg) {
        const block = boxWeg.closest("[data-wk-box]");
        const updates = {};
        (block.dataset.wkBoxKeys || "").split(",").filter(Boolean).forEach((k) => (updates[k] = 0));
        return this.schreiben("update", { updates }, block);
      }
      const dazu = t.closest("[data-wk-empf-dazu]");
      if (dazu) {
        const karte = dazu.closest("[data-wk-empf]");
        const wahl = karte.querySelector("[data-wk-empf-wahl]");
        const menge = Number(dazu.dataset.wkEmpfMenge) || 1; // Mindestbestellmenge (Roadmap 3.11)
        const bild = karte.querySelector("img");
        const name = karte.querySelector(".mhsys-wk__empf-name, .mhsys-wk__leer-kachel-name");
        dazu.disabled = true;
        // Wie die Kaufwege der Seite: Platzhalter oben in der Liste und Zaehler sofort (Roadmap 1.70) - gleich
        // nach dem Absenden, damit die Anfrage nicht auf den Aufbau wartet
        this.einlegenOffen++;
        this.platzhalter = { name: name ? name.textContent.trim() : "", bild: bild ? bild.currentSrc || bild.src : "", menge };
        const zeigen = () => {
          this.symbolZaehlen(this.symbolAnzahl() + menge);
          this.platzhalterZeigen();
        };
        this.schreiben(
          "add",
          {
            items: [
              {
                id: Number(wahl ? wahl.value : dazu.dataset.wkEmpfDazu),
                quantity: menge,
                properties: { _quelle: "warenkorb" },
              },
            ],
          },
          karte,
          { sofort: true, einlegen: true }
        );
        zeigen();
      }
    }

    // "Zur Kasse" (Fuss und Kassenleiste auf /cart), waehrend eine Menge noch wartet oder unterwegs ist: erst
    // senden, dann mit demselben Knopf weiter - sonst kaeme die Kasse mit der alten Menge an (Roadmap 1.70)
    vorDerKasse(e) {
      const form = e.target;
      if (this.kasseFrei) return (this.kasseFrei = false);
      if (!form.querySelector('[name="checkout"]') || (!this.mengeWuensche.size && !this.laufend)) return;
      e.preventDefault();
      this.mengeSenden();
      const start = Date.now();
      const warten = () => {
        if ((this.laufend || this.mengeWuensche.size) && Date.now() - start < 8000) return setTimeout(warten, 50);
        // Die Antwort hat den Inhalt neu gerendert - dasselbe Formular im neuen Inhalt, mit seinem Kassenknopf
        const neu = (form.isConnected ? form : this.inhalt.querySelector(`form.${form.classList[0]}`)) || form;
        this.kasseFrei = true;
        neu.requestSubmit(neu.querySelector('[name="checkout"]') || undefined);
      };
      warten();
    }

    beiAenderung(e) {
      const t = e.target;
      this.letzterFokus = this.fokusMerken();
      // Eingetippte Menge: sofort zeigen und senden - auch waehrend einer laufenden Anfrage (dann direkt danach)
      if (t.matches("[data-wk-eingabe]")) {
        this.menge(t.closest("[data-wk-key]"), t.value);
        return;
      }
      if (this.laufend) {
        // Eingabe verwerfen, das Neurendern nach der laufenden Aenderung zeigt den echten Stand
        if (t.matches("[data-wk-express]")) t.checked = !t.checked;
        return;
      }
      if (t.matches("[data-wk-termin-select]")) {
        const wert = t.value;
        const daten = { attributes: { Versandtag: wert } };
        // Termin gewaehlt und Express gerade aktiv: beide schliessen sich aus (Konzept Frage 4) -
        // Express raus, in derselben Anfrage statt zwei Serverrunden.
        const expressSchalter = this.inhalt.querySelector("[data-wk-express]");
        if (wert && expressSchalter && expressSchalter.checked && expressSchalter.dataset.wkExpressKey) {
          daten.updates = { [expressSchalter.dataset.wkExpressKey]: 0 };
        }
        this.schreiben("update", daten);
        return;
      }
      if (t.matches("[data-wk-express]")) {
        t.disabled = true;
        if (t.checked) {
          this.schreiben("add", { items: [{ id: Number(t.dataset.wkExpress), quantity: 1 }] }).then(() => {
            // Express eingeschaltet und ein Wunschtermin war gesetzt: den Termin zuruecksetzen
            // (Konzept Frage 4) - "So schnell wie moeglich" widerspraeche sonst dem Express-Wunsch.
            const wahl = this.inhalt.querySelector("[data-wk-termin-wahl]");
            if (wahl && wahl.dataset.wkTerminAktuell) {
              this.schreiben("update", { attributes: { Versandtag: "" } });
            }
          });
        } else if (t.dataset.wkExpressKey) {
          this.schreiben("change", { id: t.dataset.wkExpressKey, quantity: 0 });
        }
      }
    }

    // ---- Kopfzeile ----

    symbolVerbinden() {
      const symbol = document.getElementById("mhsys-wk-symbol");
      if (!symbol) return;
      this.symbol = symbol;
      symbol.setAttribute("role", "button");
      symbol.setAttribute("aria-haspopup", "dialog");
      const vorladen = () => {
        if (this.geladen || this.vorlaedt) return;
        this.vorlaedt = true;
        this.laden().finally(() => (this.vorlaedt = false));
      };
      symbol.addEventListener("pointerenter", vorladen, { passive: true });
      symbol.addEventListener("touchstart", vorladen, { passive: true });
      symbol.addEventListener("click", (e) => {
        if (this.seite) return; // auf /cart fuehrt das Symbol auf die Seite
        e.preventDefault();
        this.open(symbol);
      });
      symbol.addEventListener("keydown", (e) => {
        if (e.code === "Space") {
          e.preventDefault();
          this.open(symbol);
        }
      });
    }

    // Die Zahl, die das Symbol gerade zeigt ("99+" zaehlt als 99)
    symbolAnzahl() {
      const zahl = this.symbol && this.symbol.querySelector("[data-mhsys-wk-zahl]");
      return zahl && !zahl.hidden ? parseInt(zahl.textContent, 10) || 0 : 0;
    }

    // Die Zahl am Warenkorb-Symbol nachziehen. Das Element steht im Kopf bereits im HTML und
    // traegt seine Groesse - es wird nur der Text getauscht und ggf. versteckt. So entsteht
    // beim Nachziehen keine Layoutverschiebung.
    symbolZaehlen(anzahl) {
      if (!this.symbol) return;
      const zahl = this.symbol.querySelector("[data-mhsys-wk-zahl]");
      // Nur schreiben, was sich aendert (jeder textContent-Schreibzugriff weckt Beobachter)
      if (zahl) {
        const text = anzahl < 100 ? String(anzahl) : "99+";
        if (zahl.textContent !== text) zahl.textContent = text;
        if (zahl.hidden !== anzahl <= 0) zahl.hidden = anzahl <= 0;
      }
      // Der versteckte Text ist der Name des Links (kein aria-label, das ihn ueberdecken wuerde)
      const vorlese = this.symbol.querySelector(".mhsys-vh");
      const name = `Eikaffskerberl, ${anzahl} Artikel`;
      if (vorlese && vorlese.textContent !== name) vorlese.textContent = name;
    }

    // ---- Globo-Zusaetze nach dem Einlegen angleichen ----
    //
    // Globo legt beim Einlegen per AJAX (stayOnPdp, siehe mhsys-kaufformular.js) den Aufpreis
    // "Dein Wunschtext" immer mit Menge 1 an - auch bei Tasse Menge 3 (gemessen 18.09.2026).
    // Es gilt dieselbe Regel wie bei der Mengenaenderung im Korb (docs/relaunch/02 Abschnitt 8):
    // der Zusatz folgt der Menge seines Artikels. Ein Aufruf, mit eigener Kopfzeile, damit er
    // nicht wieder als fremder Aufruf zaehlt. Kurz gewartet, falls Globo in mehreren Anfragen einlegt.
    globoAngleichen() {
      const warten = new Promise((r) => setTimeout(r, 250));
      return warten
        .then(() => this.korbLesen())
        .then((korb) => {
          const { updates } = anhangAbweichung(korb);
          if (!Object.keys(updates).length) return;
          return fetch(`${routen().warenkorbSetzenUrl || "/cart/update"}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", [EIGEN]: "1" },
            body: JSON.stringify({ updates }),
          });
        })
        .catch(() => {});
    }

    korbLesen() {
      return fetch(`${routen().wurzelUrl || "/"}cart.js`.replace("//cart", "/cart"), { headers: { [EIGEN]: "1" } }).then((r) => r.json());
    }

    // Dieselbe Regel fuer die eigenen Wege (07.10.2026): Shopify kappt beim Einlegen den Artikel auf den Bestand, die
    // Aufpreiszeile (Gravur, Pfand - ohne Bestand) aber nicht. Live nachgestellt: Brettl mit Bestand 2, Menge 3 mit
    // Gravur eingelegt -> 2 Brettl, 3 Gravuren, der Kunde zahlte eine Gravur zu viel. Jeder Weg in den Korb endet mit
    // einem Neurendern (Kaufbereich, Schublade, /cart), danach wird hier nachgesehen - nur wenn ein Artikel
    // Aufpreiszeilen hat (data-wk-anhang) und sich seine Menge seit dem letzten Blick geaendert hat; ein Aufruf
    // /cart.js, und nur bei Abweichung ein /cart/update. Wurde die Gravur weniger, sagt die Zeile warum.
    anhangPruefen() {
      if (this.laufend || this.mengeWuensche.size || this.mengeUhr) return;
      const stand = [...this.inhalt.querySelectorAll("[data-wk-anhang]")].map((p) => `${p.dataset.wkKey}=${p.dataset.wkMenge}`).join(",");
      if (!stand || stand === this.anhangStand) return;
      this.anhangStand = stand;
      this.korbLesen()
        .then((korb) => {
          if (this.laufend || this.mengeWuensche.size) return; // inzwischen geaendert - das naechste Neurendern prueft
          const { updates, gekappt } = anhangAbweichung(korb);
          if (!Object.keys(updates).length) return;
          const posten = gekappt && this.postenFinden(gekappt);
          // Steht schon eine Meldung da (Shopify: "Aufgrund der Verfuegbarkeit wurden nur 2 Artikel ..."), bleibt sie
          // ueber das Neurendern stehen - sie sagt mehr als ein eigener Satz
          const sichtbar = this.inhalt.querySelector(".mhsys-wk__fehler:not([hidden])");
          if (sichtbar && sichtbar.textContent) this.meldung = { key: "", text: sichtbar.textContent };
          else if (posten) this.fehlerMerken(posten, "Zusatz an die Stückzahl angepasst", true);
          this.schreiben("update", { updates }, posten);
        })
        .catch(() => {});
    }

    // ---- fremde Warenkorb-Aufrufe ----

    fremdeAufrufeBeobachten() {
      const drawer = this;
      const nachher = (url) => {
        const m = WARENKORB_URL.exec(url || "");
        if (!m) return;
        if (m[1] === "add") drawer.globoAngleichen().then(() => drawer.aktualisieren(true));
        else if (drawer.geladen) drawer.laden();
      };
      const istEigen = (init) => {
        if (!init) return false;
        const h = init.headers;
        if (h && (h[EIGEN] || (typeof h.get === "function" && h.get(EIGEN)))) return true;
        // Eigenes Kaufformular: schickt ?sections selbst mit und ruft antwortEinsetzen
        return init.body instanceof FormData && init.body.has("sections");
      };

      const fetchAlt = window.fetch;
      window.fetch = function (eingabe, init) {
        const p = fetchAlt.apply(this, arguments);
        try {
          const url = typeof eingabe === "string" ? eingabe : eingabe && eingabe.url;
          if (WARENKORB_URL.test(url || "") && !istEigen(init)) {
            p.then((r) => {
              if (r.ok) nachher(url);
            }).catch(() => {});
          }
        } catch (e) {}
        return p;
      };

      const openAlt = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (methode, url) {
        this._mhsysWkUrl = String(url || "");
        return openAlt.apply(this, arguments);
      };
      const sendAlt = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (WARENKORB_URL.test(this._mhsysWkUrl || "")) {
          this.addEventListener("load", () => {
            if (this.status >= 200 && this.status < 300) nachher(this._mhsysWkUrl);
          });
        }
        return sendAlt.apply(this, arguments);
      };
    }
  }

  customElements.define("mhsys-warenkorb", MhsysWarenkorb);

  window.mhsysWarenkorb = {
    aktualisieren(oeffnen) {
      const w = document.querySelector("mhsys-warenkorb");
      return w && w.aktualisieren ? w.aktualisieren(oeffnen) : Promise.resolve();
    },
    oeffnen() {
      const w = document.querySelector("mhsys-warenkorb");
      if (w && w.open) w.open();
    },
  };
}
